var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNotificationFeedback = function SvgIconNotificationFeedback(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19 8.35A2.65 2.65 0 0 1 21.65 11v3.052c.989-.218 2 .528 2 1.615V21A2.65 2.65 0 0 1 21 23.65H10A2.65 2.65 0 0 1 7.35 21v-5.333a1.653 1.653 0 0 1 2-1.615V11A2.65 2.65 0 0 1 12 8.35zm3.35 7.317a.35.35 0 0 0-.515-.31l-5.088 2.714q-.09.047-.18.086l-.755.413a.65.65 0 0 1-.623 0l-.756-.413a3 3 0 0 1-.18-.086l-5.088-2.714a.35.35 0 0 0-.515.31V21c0 .746.604 1.35 1.35 1.35h11A1.35 1.35 0 0 0 22.35 21zM12 9.65A1.35 1.35 0 0 0 10.65 11v3.614l4.345 2.37c.324.13.685.13 1.009 0l4.346-2.37V11A1.35 1.35 0 0 0 19 9.65z"
  })));
};
export default SvgIconNotificationFeedback;